import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

export type { MoveGroupFoldersTelemetryParams } from './services/moveGroupFolder';
export { translateRestIdToOwsId } from './utils/folderIdConversionUtils';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "GroupSharedFolderActions" */ './lazyIndex'),
    { name: 'GroupSharedFolderActions' }
);

// Delay loaded components
export const lazyLoadGroupFolders: LazyAction<
    typeof lazyIndex.loadGroupFolders,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadGroupFolders);
export const lazyCreateNewGroupFolder: LazyAction<
    typeof lazyIndex.createNewGroupFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createNewGroupFolder);
export const lazyDeleteGroupFolder: LazyAction<
    typeof lazyIndex.deleteGroupFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.deleteGroupFolder);
export const lazyRenameGroupFolder: LazyAction<
    typeof lazyIndex.renameGroupFolder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.renameGroupFolder);
export const lazyMoveGroupFolder: LazyAction<typeof lazyIndex.moveGroupFolder, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.moveGroupFolder);
export const lazySubscribeToAllGroupFolderHierarchyNotifications: LazyAction<
    typeof lazyIndex.subscribeToAllGroupFolderHierarchyNotifications,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.subscribeToAllGroupFolderHierarchyNotifications);
export const lazyUnsubscribeFromGroupFolderHierarchyNotifications: LazyAction<
    typeof lazyIndex.unsubscribeFromGroupFolderHierarchyNotifications,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.unsubscribeFromGroupFolderHierarchyNotifications);
export const lazyUnsubscribeFromGroupFolderUnreadCountNotificationsForGroup: LazyAction<
    typeof lazyIndex.unsubscribeFromGroupFolderUnreadCountNotificationsForGroup,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.unsubscribeFromGroupFolderUnreadCountNotificationsForGroup);
